import React, { useEffect, useState } from "react";

export function PreviewVideo(props) {
  const videoRef = React.useRef(null);
  const [thumbnail, setThumbnail] = useState(null);

  useEffect(() => {
    const generateThumbnail = () => {
      if (videoRef.current) {
        videoRef.current.addEventListener('loadeddata', () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = videoRef.current.videoWidth;
            canvas.height = videoRef.current.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
            const dataURI = canvas.toDataURL('image/jpeg');
            setThumbnail(dataURI);
          } catch (e) {
            console.error('Error generating thumbnail', e);
          }
        });
      }
    };

    generateThumbnail();
  }, []);

  const handleVideoClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
      }}
      onClick={props.onClick}
    >
      {props?.src && (
        <video
          ref={videoRef}
          controls
          style={{ width: "100%", height: "auto" }}
          onClick={handleVideoClick}
          poster={thumbnail} // Use the generated thumbnail as a poster
        >
          <source src={props?.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
}
